module.exports = __webpack_public_path__ + "static/media/bookmark.da5678af.svg";